import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Input, Space, Row, List, Typography, Divider } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { SearchRounded, DeleteForeverRounded, EditOutlined } from "@mui/icons-material";
import { Popover, Tag, Tabs } from 'antd';
import { SwatchesPicker, MaterialPicker, SketchPicker } from 'react-color';
import { comparisonActions } from "../../../store/slices/comparison.slice";
const { Text } = Typography;

const ItemMenu = ({
  items,
  itemColors,
  onRemove,
  extraItems,
  onToggleExtraItems,
  initialSelectedItems,
  setShowSearch,
  reset,
  showAll = false
}) => {
    const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState(initialSelectedItems || []);
  const [visiblePopover, setVisiblePopover] = useState(null);

  // Filter items based on search
  const filteredItems = items.filter(item =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onUpdateColor = (color, item) => {
    // Assuming you have access to the dispatch function and action
    // You would need to pass these as props or use your own state management
    dispatch(comparisonActions.updateItemColor({id: item.id, color: color.hex}));
  };

  const renderColorPicker = (item) => (
    <div>
      <div className="mb-4">
        <Text strong>{item.label}</Text>
      </div>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Swatches" key="1">
          <SwatchesPicker
            color={itemColors?.[item.id] ?? '#1890ff'}
            onChangeComplete={(color) => onUpdateColor(color, item)}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Material" key="2">
          <MaterialPicker
            color={itemColors?.[item.id] ?? '#1890ff'}
            onChangeComplete={(color) => onUpdateColor(color, item)}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Sketch" key="3">
          <SketchPicker
            color={itemColors?.[item.id] ?? '#1890ff'}
            onChangeComplete={(color) => onUpdateColor(color, item)}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );

  return (
    <Card bordered={false} className="w-full">
      <Row justify="center" align="middle" className="py-6">
        <ButtonGroup>
          <Button
            color="primary"
            variant="contained"
            startIcon={<SearchRounded />}
            onClick={() => setShowSearch(true)}
          >
            Search Tickers
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={reset}
          >
            <DeleteForeverRounded />
          </Button>
        </ButtonGroup>
      </Row>

      <Divider />

      <Input.Search
        placeholder="Search items..."
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-4"
      />

      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={filteredItems}
        renderItem={item => (
          <List.Item
            actions={[
              <Popover
                content={renderColorPicker(item)}
                title="Edit Color"
                trigger="click"
                visible={visiblePopover === item.id}
                onVisibleChange={(visible) => setVisiblePopover(visible ? item.id : null)}
              >
                <Button
                  startIcon={<EditOutlined />}
                  className="flex items-center"
                >
                  Edit
                </Button>
              </Popover>
            ]}
          >
            <List.Item.Meta
              title={
                <div className="flex items-center">
                  <div
                    className="w-4 h-4 rounded mr-2"
                    style={{ backgroundColor: itemColors?.[item.id] ?? '#1890ff' }}
                  />
                  <Text>{item.label}</Text>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ItemMenu;